'use client';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useAuth } from '@/hooks/useAuth';
import { alertApi, CreateAlertPayload } from '@/services/api/alert.api';

export const ALERT_QUERY_KEYS = {
  all: ['alerts'] as const,
  list: () => [...ALERT_QUERY_KEYS.all, 'list'] as const,
};

/**
 * List the authenticated user's price alerts.
 */
export const useAlerts = (enabled = true) => {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: ALERT_QUERY_KEYS.list(),
    queryFn: () => alertApi.getAlerts(),
    enabled: isAuthenticated && enabled,
    staleTime: 20_000,
    refetchInterval: 60_000,
  });
};

export const useCreateAlert = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateAlertPayload) => alertApi.createAlert(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ALERT_QUERY_KEYS.all });
    },
  });
};

export const useDeleteAlert = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => alertApi.deleteAlert(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ALERT_QUERY_KEYS.all });
    },
  });
};
